import React, { useCallback } from "react";
import { ReactSVG } from "react-svg";

// icons
import { InvoicePrint, NfsePrint } from "@assets/icons";

// hooks
import { useDownloadProvider } from "@hooks/useDownloadArchive";

/** Libraries */
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Zoom,
  TransitionProps
} from "@libraries/mui";

// graphql
import { ArchiveType } from "@graphql/helpers/types.graphql";

/** Styled components */
import * as Styled from "./styles";

/** Interfaces */

export interface IInvoiceFiscalDocumentArchives {
  invoice?: ArchiveType;
  fiscalDocument?: ArchiveType;
}
interface IProps {
  open: boolean;
  onClose: () => void;
  title: any;
  invoiceFiscalDocumentArchives: IInvoiceFiscalDocumentArchives;
}

/** Transition helper component */
const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
  ) => <Zoom ref={ref} {...props} />
);

/** Component */
const PrintInvoiceDialog: React.FC<IProps> = ({
  title,
  open,
  onClose,
  invoiceFiscalDocumentArchives,
  children
}) => {
  const { downloadArchive } = useDownloadProvider();

  const handleClickPrint = useCallback(
    async (printType: "invoice" | "fiscalDocument") => {
      if (printType === "invoice"
        && invoiceFiscalDocumentArchives.invoice
      ) await downloadArchive(invoiceFiscalDocumentArchives.invoice);

      if (
        printType === "fiscalDocument"
        && invoiceFiscalDocumentArchives.fiscalDocument
      ) await downloadArchive(invoiceFiscalDocumentArchives.fiscalDocument);
    },
    [invoiceFiscalDocumentArchives, downloadArchive]
  );

  return (
    <Styled.Container
      open={open}
      onClose={onClose}
      aria-labelledby="printInvoiceDialog-title"
      aria-describedby="printInvoiceDialog-description"
      TransitionComponent={Transition}
    >
      <DialogTitle id="printInvoiceDialog-title">{title}</DialogTitle>
      <DialogContent id="printInvoiceDialog-content">
        <DialogContentText id="printInvoiceDialog-description">
          {invoiceFiscalDocumentArchives.invoice && (
            <Styled.Content onClick={() => handleClickPrint("invoice")}>
              <Styled.ContentIcon>
                <ReactSVG src={InvoicePrint} />
              </Styled.ContentIcon>
              Fatura completa
            </Styled.Content>
          )}
          {invoiceFiscalDocumentArchives.fiscalDocument && (
            <Styled.Content onClick={() => handleClickPrint("fiscalDocument")}>
              <Styled.ContentIcon>
                <ReactSVG src={NfsePrint} />
              </Styled.ContentIcon>
              Nota fiscal de serviços (NFSe)
            </Styled.Content>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Styled.DialogActions>
          <Button onClick={onClose}>Fechar</Button>
        </Styled.DialogActions>
      </DialogActions>
    </Styled.Container>
  );
};

export default PrintInvoiceDialog;
